export enum TransactionType {
    TRANSACTION_INCOME = 'TRANSACTION_INCOME',
    TRANSACTION_EXPENSE = 'TRANSACTION_EXPENSE',
    TRANSACTION_INTERNAL_TRANSFER = 'TRANSACTION_INTERNAL_TRANSFER'
}
